import React from 'react';


const SummaryItem = ({value, error}) => {

  return value ? (
    <div className="SummaryItem paragraph-main-fs8" data-testid="SummaryItem">
      {
        error ? (
          <div style={{color: 'red'}}>{value}</div>
        ) : (
          <div>{value}</div>
        )
      }
    </div>
  ) : (
    <div>-</div>
  )
};

SummaryItem.propTypes = {};

export default SummaryItem;
